export const options = [
  { label: 'Pitch', path: '/pitch', completed: false },
  { label: 'Agreement', path: '/agreement', completed: false },
  { label: 'Design Files', path: '/files', completed: false },
];
